module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bg"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('span', [_vm._v("©2016 Emulian.com All Rights Reserved")]), _vm._v(" "), _c('span', [_vm._v(" | ")]), _vm._v(" "), _c('span', [_vm._v("京ICP备16013545号-1")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-7de97d3c!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/home/footer/HomeRights.vue
// module id = 163
// module chunks = 1